import { createRouter } from "@common/router"
import routes from "./routes"
import config from "@/edita.config.js"

const router = createRouter(config, routes)

export default router
export { routes }
